import {
  compact,
  flatMap,
  groupBy,
  includes,
  keys,
  map,
  minBy,
  reject,
  size,
  without,
} from "lodash";

export const checkIsDefaultGroupAvatar = (imageSrc) => {
  return includes(imageSrc, "group-icon.png");
};

export const distinctUpcomingTasks = (tasks) => {
  const groupedData = groupBy(tasks, "parentId");
  const parentIds = without(keys(groupedData), "null", null, "");
  const duplicatedUpcomingData = map(parentIds, (parentId) => {
    const childrenTasks = groupedData[parentId];
    if (size(childrenTasks) <= 1) return [];
    const earlyTask = minBy(childrenTasks, "dueDate");
    return without(map(childrenTasks, "key"), earlyTask?.key);
  });
  const needRemovedIds = compact(flatMap(duplicatedUpcomingData));
  return reject(tasks, ({ key }) => includes(needRemovedIds, key));
};
